import React, { useMemo } from "react";
import { Navigate } from "react-router-dom";
import { buildContextPath } from "config/contextModules";
import { useLocationContext } from "context/LocationContext";
import useAuth from "hooks/useAuth";
import NationalDashboard from "pages/dashboards/NationalDashboard";
import RegionalDashboard from "pages/dashboards/RegionalDashboard";
import DistrictDashboard from "pages/dashboards/DistrictDashboard";
import {
  getDashboardVariantForLocation,
  getDefaultDashboardLocation,
  getUserDashboardScope,
  isDashboardLocationAllowed,
} from "utils/dashboardScope";

export default function DashboardModuleAdapter() {
  const { user } = useAuth();
  const { currentLocation, orgTree, isOrgTreeLoading } = useLocationContext();

  const roleScope = useMemo(() => getUserDashboardScope(orgTree, user), [orgTree, user]);
  const defaultDashboardLocation = useMemo(
    () => getDefaultDashboardLocation(orgTree, user),
    [orgTree, user],
  );
  const isCurrentLocationAllowed = useMemo(
    () => isDashboardLocationAllowed(currentLocation, orgTree, user),
    [currentLocation, orgTree, user],
  );

  if (
    !isOrgTreeLoading &&
    currentLocation?.level !== "national" &&
    roleScope !== "national" &&
    !isCurrentLocationAllowed &&
    defaultDashboardLocation
  ) {
    return <Navigate to={buildContextPath(defaultDashboardLocation, "dashboard")} replace />;
  }

  switch (getDashboardVariantForLocation(currentLocation)) {
    case "regional":
      return <RegionalDashboard />;

    case "district":
      return <DistrictDashboard />;

    default:
      return <NationalDashboard />;
  }
}
